module.exports = __webpack_public_path__ + "img/assist-icon.d61d0884.svg";